var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 128",
    height: 24,
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.26 87.71c-3.32 4.36-9.98 12.93-14.26 18.45-4.28-5.52-10.94-14.09-14.26-18.45-10.82-14.13-17.06-24.99-17.06-38.7 0-17.33 14.04-31.43 31.32-31.43s31.32 14.1 31.32 31.43c0 13.71-6.24 24.57-17.06 38.7zM42 8C19.4 8 1 26.45 1 49.13c0 18.12 9.36 31.88 18.94 44.42 5.12 6.69 18.12 23.4 18.12 23.4L42 122l3.94-5.05s13-16.71 18.12-23.4C73.64 81.01 83 67.25 83 49.13 83 26.45 64.6 8 42 8m0 24c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.6892f9ac696c9ae43096358a3c7d9558.svg";
export { ForwardRef as ReactComponent };